function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_26",
  "data-name": "Group 26",
  transform: "translate(-1454 -1985)"
}, React.createElement("rect", {
  id: "Rectangle_16",
  "data-name": "Rectangle 16",
  width: 100,
  height: 100,
  rx: 12,
  transform: "translate(1454 1985)",
  fill: "#cc2127"
}), React.createElement("path", {
  id: "Forma_1",
  "data-name": "Forma 1",
  d: "M43.449,51.936,23.286,68.914A4.15,4.15,0,0,0,26.1,70H74.9a4.131,4.131,0,0,0,2.8-1.086L57.553,51.936,50.5,58ZM74.9,30H26.1a4.128,4.128,0,0,0-2.8,1.092L50.5,54,77.712,31.084A4.136,4.136,0,0,0,74.9,30ZM22,66.742,41.677,50.316,22,33.512v33.23Zm57,0V33.5L59.323,50.316Z",
  transform: "translate(1454 1985)",
  fill: "#fff",
  fillRule: "evenodd"
}));

var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.75fde221.svg";
export { ForwardRef as ReactComponent };